import axios from 'axios'

const settings = window.wisenetwork || {}

export default {
    resetCart() {
        return axios({
            method: 'GET',
            url: '/?action=resetcart'
        })
    },
    
    removeFromCart(cartProductId) {
        return axios({
            method: 'POST',
            url: settings.REST_URL + '/carts/my/products/' + cartProductId,
            withCredentials: true,
            data: {
                quantity: 0
            }
        })
    },
    
    deleteCartOrder() {
        return axios({
            method: 'DELETE',
            url: settings.REST_URL + '/carts/my/order',
            withCredentials: true
        })
    },
    
    createMockReservation(data) {
        const status = 2;
        
        return axios({
            method: 'POST',
            url: `${ settings.REST_URL }/reservations/order/${status}`,
            withCredentials: true,
            data
        })
    },

    activateOrder(orderId, hash) {
        return axios({
            method: 'GET',
            url: `?action=activateorder&orderId=${ orderId }&hash=${ hash }`,
        })
    },

    disableTime(data) {
        const status = 4;
        
        return axios({
            method: 'POST',
            url: `${ settings.REST_URL }/reservations/order/${status}`,
            withCredentials: true,
            data
        })
    },
    
    addToCart(data) {
        return axios({
            method: 'POST',
            url: settings.REST_URL + '/carts/my/products', //?action=addToCart
            withCredentials: true,
            headers: {
            },
            data
        })
    },
    
    getProductInfo(productId) {
        return axios({
            method: 'GET',
            url: settings.REST_URL + '/products/?select=productid,meta,type,price,maximum,visibility,active,manufacturer,images&productid='+productId,
            withCredentials: true,
            //headers: {}
        })
    },
    
    // EcomReservation
    getReservationSettings(productId, date) {
        const params = {
            productid: productId,
            date
        }
        
        return axios({
            method: 'GET',
            url: `${ settings.REST_URL }/reservations/calendarsettings/?${ $.param(params) }`,
            withCredentials: true,
        })
    },

    getReservations(productId, date, weekMode = false, type = 1, adminMode = false) {
        const params = {
            productid: productId,
            date
        };
        
        if (weekMode) {
            params.week = 1;
        }

        if (adminMode) {
            params.mod = 1;
        }

        if (type === 5) {
            params.golf = 1;
        }
        
        return axios({
            method: 'GET',
            url: `${ settings.REST_URL }/reservations/?${ $.param(params) }`,
            withCredentials: true,
        })
    },
    
    // EcomReservation
    /**
     * 
     * @param {Array} resources - array of ids
     * @param {String} dateTimeStart - format 'YYYY-MM-DD HH:mm'
     * @param {String} dateTimeEnd - format 'YYYY-MM-DD HH:mm'
     * @returns {Promise}
     */
    getResourceReservations(resources, dateTimeStart, dateTimeEnd) {
        const params = $.param({
            resources,
            dateTimeStart,
            dateTimeEnd
        });
        
        return axios({
            method: 'GET',
            url: `${ settings.REST_URL }/reservations/getresourcereservations/?${ params }`,
            withCredentials: true,
        })
    },
    
    getMyCart() {
        return axios({
            method: 'GET',
            url: settings.REST_URL + '/carts/my/products',
            withCredentials: true,
            headers: {
            }
        })
    },
    
    deactivateReservationTime(reservationTimeId) {
        const data = {
            reservationtimeid: reservationTimeId
        }

        return axios({
            method: 'GET',
            url: `${ settings.REST_URL }/reservations/deactivatereservationtime/?${ $.param(data) }`,
            withCredentials: true,
        })
    },
    
    editReservationTime(data) {
        return axios({
            method: 'POST',
            url: `${ settings.REST_URL }/reservations/edittime/`,
            data,
            withCredentials: true,
        })
    },

    getUserGolfReservations(params = {}) {
        const paramString = Object.keys(params).length > 0 ? '?'+$.param(params) : '';

        return axios({
            method: 'GET',
            url: `${ settings.REST_URL }/reservations/getusergolfreservations/${ paramString }`,
            withCredentials: true,
        })
    },

    getUserReservations(params = {}) {
        const paramString = Object.keys(params).length > 0 ? '?'+$.param(params) : '';

        return axios({
            method: 'GET',
            url: `${ settings.REST_URL }/reservations/getuserreservations/${ paramString }`,
            withCredentials: true,
        })
    },

    confirmTeeTime(reservationTimeId) {
        return axios({
            method: 'GET',
            url: `${ settings.REST_URL }/reservations/confirmgolfteetime/?reservationtimeid=${ reservationTimeId }`,
            withCredentials: true,
        })
    },

    // when an admin accidentally confirms a tee time, they want to cancel that action, not cancel the tee time
    cancelConfirmedTeeTime(reservationTimeId) {
        return axios({
            method: 'GET',
            url: `${ settings.REST_URL }/reservations/confirmgolfteetime/?reservationtimeid=${ reservationTimeId }&cancel=1`,
            withCredentials: true,
        })
    },

    setReservationSaleMode(data) {
        return axios({
            method: 'POST',
            url: `${ settings.REST_URL }/reservations/setreservationsalemode/`,
            data,
            withCredentials: true,
        })
    },

    pushResourceComment(data) {
        return axios({
            method: 'POST',
            url: `${ settings.REST_URL }/reservations/pushresourcecomment/`,
            data,
            withCredentials: true,
        })
    },

    getShareOwners() {
        return axios({
            method: 'GET',
            url: `${ settings.REST_URL }/shareowners/`,
            withCredentials: true,
        })
    },
}